// ------- fade-up（Intersection Observer） -------
document.addEventListener("DOMContentLoaded", function () {
  const targets = document.querySelectorAll(".fadeUpTrigger");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fadeUp");
      } else {
        entry.target.classList.remove("fadeUp");
      }
    });
  }, {
    threshold: 0.1, // 10%が表示された時に反応
  });

  targets.forEach((target) => observer.observe(target));
});

// ------- fade-in（scroll-based） -------
function fadeInAnime() {
  const elements = document.querySelectorAll('.fadeInTrigger');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  elements.forEach(function(el) {
    const elemPos = el.getBoundingClientRect().top + scroll + 10;
    if (scroll >= elemPos - windowHeight) {
      el.classList.add('fadeIn');
    } else {
      el.classList.remove('fadeIn');
    }
  });
}

// 初回読み込み + スクロール時に実行
window.addEventListener('load', fadeInAnime);
window.addEventListener('scroll', fadeInAnime);

// ------- X軸スライド（slideX） -------
document.addEventListener('DOMContentLoaded', function () {
  function onScrollOrLoad() {
    const elements = document.querySelectorAll('.slideX');
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;

    elements.forEach(function (el) {
      const target = el.getBoundingClientRect().top + scroll;

      if (scroll >= target - windowHeight + 30) {
        el.classList.add('slideX-animated');
      } else {
        el.classList.remove('slideX-animated');
      }
    });
  }

  window.addEventListener('load', onScrollOrLoad);
  window.addEventListener('scroll', onScrollOrLoad);
});
